import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { SiteLayout, RootRedirect } from "./components/site/SiteLayout";
import Home from "./pages/Home";
import Stones from "./pages/Stones";
import StoneDetail from "./pages/StoneDetail";
import Bespoke from "./pages/Bespoke";
import Process from "./pages/Process";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Legal, { NotFound } from "./pages/Legal";
import AdminLogin from "./pages/admin/AdminLogin";
import Admin from "./pages/admin/Admin";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/:lang" element={<SiteLayout />}>
          <Route index element={<Home />} />
          <Route path="stones" element={<Stones />} />
          <Route path="stones/:code" element={<StoneDetail />} />
          <Route path="bespoke-objects" element={<Bespoke />} />
          <Route path="process" element={<Process />} />
          <Route path="about" element={<About />} />
          <Route path="start-a-project" element={<Contact />} />
          <Route path="privacy" element={<Legal doc="privacy" />} />
          <Route path="cookies" element={<Legal doc="cookies" />} />
          <Route path="legal" element={<Legal doc="legal" />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
      <Toaster position="bottom-right" toastOptions={{ style: { borderRadius: 0, background: "#1A1A1A", color: "#FFFFFF", border: "none" } }} />
    </BrowserRouter>
  );
}

export default App;
